<template>
  <section class="w-full bg-[#181819] h-auto relative mb-5 video-hero" :class="{ 'px-4': isMobile }">
    <div class="mx-auto w-full mt-4 max-w-[1120px]">
      <ArticleBreadcrumb class="sm:mx-2" />
      <VideoWrapper />
    </div>
  </section>
</template>

<script>
import { defineComponent, provide } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import ArticleBreadcrumb from '../article/components/ArticleBreadcrumb';
import VideoWrapper from './components/VideoWrapper';

export default defineComponent({
  components: {
    ArticleBreadcrumb,
    VideoWrapper,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { article } = props;
    const { isMobile } = useDevice();
    provide('article', article);

    return { isMobile };
  },
});
</script>

<style lang="scss">
.hero-bottom-line {
  background: linear-gradient(90deg, #ff3100 0%, #ff8700 25.6%, #90ff00 48.07%, #00ffed 64.26%, #00c5ff 83.07%, #0c00fe 100.32%);
}
.hero-bottom-button {
  background: linear-gradient(90deg, #0c0cfe -28.07%, #ff3b01 141.52%);
}
</style>
